<template>
  <div class="flex items-center">
    <label :for="id" class="block w-22 sm:w-20 flex-shrink-0 mr-2">{{
      label
    }}</label>
    <div class="w-full relative border bg-white">
      <div
        class="absolute inset-y-0 right-0 flex items-center justify-center w-11 h-11 border-l pr-px z-10"
      >
        <div class="caret bg-black"></div>
      </div>
      <select
        :id="id"
        :name="name"
        class="relative block w-full h-11 bg-transparent pl-4 pr-11 appearance-none rounded-none z-20"
        @change="$emit('input', $event)"
      >
        <option
          v-for="number in max + 1"
          :key="number - 1"
          :selected="number - 1 === parseInt(value)"
        >
          {{ number - 1 }}
        </option>
      </select>
    </div>
  </div>
</template>
<script>
export default {
  name: "NumericSelect",

  props: {
    id: {
      type: String,
      required: true,
    },

    name: {
      type: String,
      default: "",
    },

    label: {
      type: String,
      required: true,
    },

    max: {
      type: Number,
      required: true,
    },

    value: {
      type: String,
      required: true,
    },
  },
};
</script>
